export enum LoginFormType {
  SIGNIN = 'signin',
  SIGNUP = 'signup',
  RESET = 'reset',
}
